import {
  HHBaseTable,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const UploadedFile = ({
  file,
}: {
  file: File | null;
}): JSX.Element | null =>
  file ? (
    <HHBaseTable
      headerRowBottomBorder="1px solid rgba(0, 0, 0, 0.12)"
      bodyRowBorder={{
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      }}
      bodyTypographyVariant="inherit"
      tableHeaders={[
        { value: 'File Name', align: 'left' },
        { value: 'Size', align: 'left' },
      ]}
      bodyContent={[
        {
          name: {
            value: (
              <HHStack direction="row" alignItems="center" gap={1}>
                <InsertDriveFileIcon sx={{ fontSize: 18, color: '#4caf50' }} />
                <HHTypography hhVariant="body1">{file.name}</HHTypography>
              </HHStack>
            ),
          },
          size: {
            value: (
              <HHTypography hhVariant="body2" sx={{ color: 'text.secondary' }}>
                {(file.size / 1024).toFixed(2)} KB
              </HHTypography>
            ),
          },
        },
      ]}
    />
  ) : null;
